import { createAction, props } from '@ngrx/store';

export const loadCompetitions = createAction(
  '[Competition] Load Competitions'
);

export const loadCompetitionsSuccess = createAction(
  '[Competition] Load Competitions Success',
  props<{ competitions: any[] }>()
);
export const loadCompetitionsFailure = createAction(
  '[Competition] Load Competitions Failure',
  props<{ error: any }>()
);
